import { ClientApiFactory } from '@boostbrothers/web-api/web-gateway-api';
import { TextButton } from '@boostbrothers/web-ui/web';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import IconUserProfile from '~assets/icons/icon-user-profile.svg';
import useToast from '~hooks/useToast';
import useViewTransition from '~hooks/useViewTransition';

const Header = () => {
  const { navigateWithTransition } = useViewTransition();
  const { addToast } = useToast();
  const queryClient = useQueryClient();

  const {
    data: userInfo,
    isLoading,
    isFetched,
  } = useQuery({
    queryKey: ['userInfo'],
    queryFn: () => ClientApiFactory('GET /v1/cms/editor-users')(),
    staleTime: Infinity,
  });

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    navigateWithTransition('/login');
    addToast({
      state: 'success',
      title: '로그아웃 되었습니다.',
      position: 'bottom-center',
    });

    setTimeout(() => {
      queryClient.clear();
    }, 500);
  };

  if (isLoading && !isFetched) return null;

  return (
    <header className="flex shrink-0 items-center gap-2">
      {/* 사용자 프로필 */}
      <div className="flex h-12 w-12 shrink-0 items-center justify-center">
        <img src={IconUserProfile} alt="user profile" width={48} height={48} />
      </div>
      <span className="text-lg font-bold text-CoolGray-900">
        {userInfo?.nickname}
      </span>
      <TextButton
        label="로그아웃"
        size="xs"
        className="font-normal !text-Blue-300 hover:text-Blue-300 hover:underline"
        onClick={handleLogout}
      />
    </header>
  );
};

export default Header;
